import { render } from "./PhishingDetailsView.vue?vue&type=template&id=e4fd236e&scoped=true"
import script from "./PhishingDetailsView.vue?vue&type=script&lang=js"
export * from "./PhishingDetailsView.vue?vue&type=script&lang=js"

import "./PhishingDetailsView.vue?vue&type=style&index=0&id=e4fd236e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4fd236e"]])

export default __exports__